/**
 * @publicapi
 * @category Tezos
 */
export var TezosOperationType;
(function (TezosOperationType) {
    TezosOperationType["ACTIVATE_ACCOUNT"] = "activate_account";
    TezosOperationType["ATTESTATION"] = "attestation";
    TezosOperationType["ATTESTATIONS_AGGREGATE"] = "attestations_aggregate";
    TezosOperationType["ATTESTATION_WITH_DAL"] = "attestation_with_dal";
    TezosOperationType["BALLOT"] = "ballot";
    TezosOperationType["DAL_PUBLISH_COMMITMENT"] = "dal_publish_commitment";
    TezosOperationType["DELEGATION"] = "delegation";
    TezosOperationType["DRAIN_DELEGATE"] = "drain_delegate";
    TezosOperationType["DOUBLE_ATTESTATION_EVIDENCE"] = "double_attestation_evidence";
    TezosOperationType["DOUBLE_BAKING_EVIDENCE"] = "double_baking_evidence";
    TezosOperationType["DOUBLE_ENDORSEMENT_EVIDENCE"] = "double_endorsement_evidence";
    TezosOperationType["DOUBLE_PREATTESTATION_EVIDENCE"] = "double_preattestation_evidence";
    TezosOperationType["DOUBLE_PREENDORSEMENT_EVIDENCE"] = "double_preendorsement_evidence";
    TezosOperationType["ENDORSEMENT"] = "endorsement";
    TezosOperationType["ENDORSEMENT_WITH_DAL"] = "endorsement_with_dal";
    TezosOperationType["EVENT"] = "event";
    TezosOperationType["FAILING_NOOP"] = "failing_noop";
    TezosOperationType["INCREASE_PAID_STORAGE"] = "increase_paid_storage";
    TezosOperationType["ORIGINATION"] = "origination";
    TezosOperationType["PREATTESTATION"] = "preattestation";
    TezosOperationType["PREATTESTATIONS_AGGREGATE"] = "preattestations_aggregate";
    TezosOperationType["PREENDORSEMENT"] = "preendorsement";
    TezosOperationType["PROPOSALS"] = "proposals";
    TezosOperationType["REGISTER_GLOBAL_CONSTANT"] = "register_global_constant";
    TezosOperationType["REVEAL"] = "reveal";
    TezosOperationType["SEED_NONCE_REVELATION"] = "seed_nonce_revelation";
    TezosOperationType["SET_DEPOSITS_LIMIT"] = "set_deposits_limit";
    TezosOperationType["SMART_ROLLUP_ADD_MESSAGES"] = "smart_rollup_add_messages";
    TezosOperationType["SMART_ROLLUP_CEMENT"] = "smart_rollup_cement";
    TezosOperationType["SMART_ROLLUP_EXECUTE_OUTBOX_MESSAGE"] = "smart_rollup_execute_outbox_message";
    TezosOperationType["SMART_ROLLUP_ORIGINATE"] = "smart_rollup_originate";
    TezosOperationType["SMART_ROLLUP_PUBLISH"] = "smart_rollup_publish";
    TezosOperationType["SMART_ROLLUP_RECOVER_BOND"] = "smart_rollup_recover_bond";
    TezosOperationType["SMART_ROLLUP_REFUTE"] = "smart_rollup_refute";
    TezosOperationType["SMART_ROLLUP_TIMEOUT"] = "smart_rollup_timeout";
    TezosOperationType["TICKET_UPDATES"] = "ticket_updates";
    TezosOperationType["TRANSACTION"] = "transaction";
    TezosOperationType["TRANSFER_TICKET"] = "transfer_ticket";
    TezosOperationType["UPDATE_CONSENSUS_KEY"] = "update_consensus_key";
    TezosOperationType["UPDATE_COMPANION_KEY"] = "update_companion_key";
    TezosOperationType["VDF_REVELATION"] = "vdf_revelation";
    TezosOperationType["DOUBLE_CONSENSUS_OPERATION_EVIDENCE"] = "double_consensus_operation_evidence";
    TezosOperationType["DAL_ENTRAPMENT_EVIDENCE"] = "dal_entrapment_evidence";
})(TezosOperationType || (TezosOperationType = {}));
//# sourceMappingURL=OperationTypes.js.map